define('drops/drawings/businessprocessElement',['jquery', 'lq/drop', 'lq/oop', 'lq/point', './businessprocessEvents', 'lq/design/editors/dropExtensionsClicks'],
    function ($, Drop, oop, Point, businessProcessEvents, clicks) {
    'use strict';

    function BusinessProcessElement($element, defaults, options) {
        Drop.call(this, $element, defaults, options);
    };

    Drop.extend(BusinessProcessElement, Drop);
    
    oop.makeExtendable(BusinessProcessElement);

    BusinessProcessElement.prototype.preRender = function () {
        this.applyPosition();
    };

    BusinessProcessElement.prototype.acceptsFlowConnections = true;

    BusinessProcessElement.prototype.getAnchoringPoints = function () {
        return [
            new Point(Math.round(this.data.position.x), Math.round(this.data.position.y + (this.data.size.y / 2))),
            new Point(Math.round(this.data.position.x + (this.data.size.x / 2)), Math.round(this.data.position.y)),
            new Point(Math.round(this.data.position.x + this.data.size.x), Math.round(this.data.position.y + (this.data.size.y / 2))),
            new Point(Math.round(this.data.position.x + (this.data.size.x / 2)), Math.round(this.data.position.y + this.data.size.y))
        ];
    };

    BusinessProcessElement.prototype.informPositionChanged = function() {
        businessProcessEvents.informListeners('bp_element_moved_' + this.data.id, this);
    };

    BusinessProcessElement.prototype.onResizing = function () {
        businessProcessEvents.informListeners('bp_element_moved_' + this.data.id, this);
    }

    return BusinessProcessElement;
});
